module.exports = __webpack_public_path__ + "img/01.a591ac27.gif";